import classNames from "classnames";
import { Form } from "components/Forms";
import { buildWidgetInstanceId } from "features/widgets";
import { WIDGETS_REGISTRY } from "features/widgets/widgets.config";
import { useRouter } from "next/router";
import {
  Action,
  Container,
  Heading4,
  Icon,
  ImageLite,
  ModalWrapper,
  PageLink,
  Paragraph,
} from "shared/components";
import { useToggle } from "shared/hooks";

import styles from "./Content080.module.scss";

export const Content080 = ({ payload }) => {
  const title = payload?.title ?? "";
  const description = payload?.description ?? "";
  const image = payload?.preview ?? {};
  const position = payload?.position ?? "left";

  const requestType = payload.button?.type ?? "form";
  const form = payload.button?.form ?? {};
  const buttonText = payload.button?.buttonText ?? "";
  const requestLink = payload.button?.link ?? "";

  const instanceId = buildWidgetInstanceId(
    "080",
    payload.id,
    WIDGETS_REGISTRY.CONTENT
  );

  const { query } = useRouter();

  const { opened, onOpen, onClose } = useToggle();

  return (
    <div className={styles.wrapper}>
      <Container>
        <div className={classNames(styles.block, styles[position])}>
          <div className={styles.content}>
            <Heading4 className={styles.title} color="light">
              {title}
            </Heading4>
            <Paragraph className={styles.description} color="light">
              {description}
            </Paragraph>
            {requestType === "form" ? (
              <Action onClick={onOpen}>
                <span className={styles.arrow}>
                  <Paragraph color="light" appearance="bigger">
                    {buttonText}
                  </Paragraph>
                  <Icon className={styles.icon} name="arrow_right" />
                </span>
              </Action>
            ) : (
              <PageLink link={requestLink}>
                <span className={styles.arrow}>
                  <Paragraph color="light" appearance="bigger">
                    {buttonText}
                  </Paragraph>
                  <Icon className={styles.icon} name="arrow_right" />
                </span>
              </PageLink>
            )}

            {opened && (
              <ModalWrapper onCloseModal={onClose}>
                <Form
                  item={form}
                  metaData={{ page: query.slug }}
                  instanceId={instanceId}
                  onReset={onClose}
                />
              </ModalWrapper>
            )}
          </div>
          <div className={styles.preview}>
            <ImageLite image={image} className={styles.image} />
          </div>
        </div>
      </Container>
    </div>
  );
};

export default Content080;
